<template>
    <v-card outlined>
        <v-card-title class="justify-center font-weight-bold subtitle-2 text-uppercase">{{$t('orderPrice')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-2">
            <v-row>
                <v-col cols="4" class="text-center">
                    <span class="font-weight-bold body-2">{{$t('seller')}}</span>
                </v-col>
                <v-col cols="3" class="text-center">
                    <span class="font-weight-bold body-2">{{$t('quantityCut')}}</span>
                </v-col>
                <v-col cols="5" class="text-center">
                    <span class="font-weight-bold body-2">{{$t('price')}}</span>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <agrolink-amount
            v-if="agrolinkOrderProducts.length > 0"
            :orders="agrolinkOrderProducts"
        ></agrolink-amount>
        <no-agrolink-amount
            v-if="orderProducts.length > 0"
            v-for="(order, idx) in orderProducts"
            :key="idx"
            :index="idx"
            :order="order"
        ></no-agrolink-amount>
        <v-card-text class="py-2">
            <v-row class="d-flex align-center">
                <v-col cols="7"><span class="text-body-1 font-weight-bold text-uppercase">{{ $t('total') }} {{ $t('withoutDelivery') }}:</span></v-col>
                <v-col cols="5" class="text-end subtitle-1">
                    <span class="font-weight-bold">{{ formattedPrice }}</span>
                    <span v-if="totalPrice" class="text-lowercase font-weight-bold">{{ currency.cyrName }}</span>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text class="text-center">
            <v-btn depressed class="main--yellow white--text text-md-caption mr-4 mb-3" :disabled="!valid" @click="clickBuy">
                {{ $t('confirmOrder') }}
            </v-btn>
            <div class="pa-2" v-if="hasLiqpayCommission">{{ $t('orderConfirmMessage3') }}</div>
            <div class="pa-2">{{ $t('orderConfirmMessage1') }}</div>
            <div class="pa-2">{{ $t('orderConfirmMessage2') }}
                <router-link
                    class="teal--text font-weight-medium"
                    :to="{ name: 'textPage', params: { pageName: 'usloviya-polzovaniya'} }"
                >
                    {{ $t('usersAgreement') }}
                </router-link>
                {{ $t('and') }}
                <router-link
                    class="teal--text font-weight-medium"
                    :to="{ name: 'textPage', params: { pageName: 'politika-konfidentsialnosti'} }"
                >
                    {{ $t('withPrivacyPolicies') }}
                </router-link>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import AgrolinkAmount from "./AgrolinkAmount";
import NoAgrolinkAmount from "./NoAgrolinkAmount";
import OrderDataProvider from "../../../../app-front/mixins/OrderDataProvider";
import numberFormat from "../../../../utils/numberFormat";

export default {
    name: "OrderAmount",
    components: { AgrolinkAmount, NoAgrolinkAmount },
    mixins: [ OrderDataProvider ],
    props: [ 'valid' ],
    computed: {
        currency() {
            return this.$store.getters.currencies.find(item => item.id === 1)
        },
        liqpayCommission() {
            return this.$store.getters.liqpayCommission;
        },
        initialProducts() {
            return !this.$route.query.sellerID ? this.orderInitialProducts : this.orderInitialProducts.filter(order => {
                return order.seller.id === parseInt(this.$route.query.sellerID);
            });
        },
        initialInProcess() {
            return !this.$route.query.sellerID ? this.inProcessProducts : this.inProcessProducts.filter(order => {
                return order.sellerID === parseInt(this.$route.query.sellerID);
            });
        },
        orderProducts() {
            const orders = [];
            this.initialProducts.forEach((item) => {
                const products = item.data.filter(product => product.selfShipment !== true)
                if (products.length > 0) {
                    orders.push({
                        data: products,
                        policies: item.policies,
                        seller: item.seller,
                    })
                }
            })
            return orders;
        },
        agrolinkOrderProducts() {
            const orders = [];
            this.initialProducts.forEach((item) => {
                const products = item.data.filter(product => product.selfShipment === true)
                if (products.length > 0) {
                    orders.push({
                        data: products,
                        policies: item.policies,
                        seller: item.seller,
                    })
                }
            })
            return orders;
        },
        liqpayCommissionSum() {
            const sum = this.initialInProcess.reduce((accum, item) => {
                if(item.paymentWay && item.paymentWay.value && item.paymentWay.value.id && item.paymentWay.value.id === 10) {
                    const curValue = item.priceWithDiscount ? item.priceWithDiscount : item.priceSummary;
                    return accum + curValue;
                }
                return accum;
            }, 0);
            return sum * this.liqpayCommission;
        },
        totalPrice() {

            let sum =  this.initialInProcess.reduce((sum, item) => {
                const curValue = item.priceWithDiscount ? item.priceWithDiscount : item.priceSummary;
                return sum + curValue;
            }, 0);

            if(this.hasLiqpayCommission) {
                sum += this.liqpayCommissionSum;
            }
            return sum;
        },
        formattedPrice() {
            return this.totalPrice ? numberFormat(this.totalPrice, '2', '.', ' ') : '';
        },
    },
    methods: {
        clickBuy() {
            this.$emit('click-buy');
        },
    },
}
</script>

<style scoped>

</style>
